import SecurityService from './SecurityService.js';

function httpCall(url, method, data) {
  return new Promise(function (resolve) {
    SecurityService.updateToken(async function () {
      const options = {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${SecurityService.getToken()}`,
        }
      };
      if (data) {
        options.body = JSON.stringify(data);
      }
      resolve(await fetch(url, options));
    });
  });
}

async function getBranches(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/branches${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBranches"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getCountBranches(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-branches${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountBranches"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function postBranch(branch) {
  const response = await httpCall(`/api/branch`, 'post', branch);
  if (!response.ok) {
    const error = new Error('Error executing "postBranch"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getBranch(branchId) {
  const response = await httpCall(`/api/branch/${branchId}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBranch"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putBranch(branchId, updatedBranchData) {
  const response = await httpCall(`/api/branch/${branchId}`, 'put', updatedBranchData);
  if (!response.ok) {
    const error = new Error('Error executing "putBranch"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function deleteBranch(branchId) {
  const response = await httpCall(`/api/branch/${branchId}`, 'delete');
  if (!response.ok) {
    const error = new Error('Error executing "deleteBranch"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function getBudgetCapital(budgetCapitalId) {
  const response = await httpCall(`/api/budget-capital/${budgetCapitalId}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBudgetCapital"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putBudgetCapitalSetInRevision(budgetCapitalId) {
  const response = await httpCall(`/api/budget-capital/${budgetCapitalId}/set-in-revision`, 'put');
  if (!response.ok) {
    const error = new Error('Error executing "putBudgetCapitalSetInRevision"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putBudgetCapitalSetConfirmed(budgetCapitalId) {
  const response = await httpCall(`/api/budget-capital/${budgetCapitalId}/set-confirmed`, 'put');
  if (!response.ok) {
    const error = new Error('Error executing "putBudgetCapitalSetConfirmed"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putBudgetCapitalSetSent(budgetCapitalId) {
  const response = await httpCall(`/api/budget-capital/${budgetCapitalId}/set-sent`, 'put');
  if (!response.ok) {
    const error = new Error('Error executing "putBudgetCapitalSetSent"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putBudgetCapital(budgetCapitalId, data) {
  const response = await httpCall(`/api/budgetCapital/${budgetCapitalId}`, 'put', data);
  if (!response.ok) {
    const error = new Error('Error executing "putBudgetCapital"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getBudgetCapitalAudits(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/budget-capital-audits${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBudgetCapitalAudits"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getCountBudgetCapitalAudits(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-budget-capital-audits${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountBudgetCapitalAudits"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function postBudgetCapitalComment(budgetCapitalId, data) {
  const response = await httpCall(`/api/budget-capital/${budgetCapitalId}/comment`, 'post', data);
  if (!response.ok) {
    const error = new Error('Error executing "postBudgetCapitalComment"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getBudgetCapitalComments(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/budget-capital-comments${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBudgetCapitalComments"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getCountBudgetCapitalComments(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-budget-capital-comments${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountBudgetCapitalComments"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getBudgetOperation(budgetOperationId) {
  const response = await httpCall(`/api/budget-operation/${budgetOperationId}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBudgetOperation"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putBudgetOperationSetInRevision(budgetOperationId) {
  const response = await httpCall(`/api/budget-Operation/${budgetOperationId}/set-in-revision`, 'put');
  if (!response.ok) {
    const error = new Error('Error executing "putBudgetOperationSetInRevision"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putBudgetOperationSetConfirmed(budgetOperationId) {
  const response = await httpCall(`/api/budget-Operation/${budgetOperationId}/set-confirmed`, 'put');
  if (!response.ok) {
    const error = new Error('Error executing "putBudgetOperationSetConfirmed"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putBudgetOperationSetSent(budgetOperationId) {
  const response = await httpCall(`/api/budget-Operation/${budgetOperationId}/set-sent`, 'put');
  if (!response.ok) {
    const error = new Error('Error executing "putBudgetOperationSetSent"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putBudgetOperation(budgetOperationId, data) {
  const response = await httpCall(`/api/budgetOperation/${budgetOperationId}`, 'put', data);
  if (!response.ok) {
    const error = new Error('Error executing "putBudgetOperation"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getBudgetOperationAudits(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/budget-operation-audits${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBudgetOperationAudits"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getCountBudgetOperationAudits(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-budget-operation-audits${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountBudgetOperationAudits"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function postBudgetOperationComment(budgetOperationId, data) {
  const response = await httpCall(`/api/budget-Operation/${budgetOperationId}/comment`, 'post', data);
  if (!response.ok) {
    const error = new Error('Error executing "postBudgetOperationComment"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getBudgetOperationComments(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/budget-operation-comments${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBudgetOperationComments"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getCountBudgetOperationComments(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-budget-operation-comments${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountBudgetOperationComments"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getBusinessUnits(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/business-units${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBusinessUnits"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getCountBusinessUnits(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-business-units${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountBusinessUnits"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function postBusinessUnit(businessUnit) {
  const response = await httpCall(`/api/business-unit`, 'post', businessUnit);
  if (!response.ok) {
    const error = new Error('Error executing "postBusinessUnit"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getBusinessUnit(businessUnitId) {
  const response = await httpCall(`/api/business-unit/${businessUnitId}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBusinessUnit"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putBusinessUnit(businessUnitId, updatedBusinessUnitData) {
  const response = await httpCall(`/api/business-unit/${businessUnitId}`, 'put', updatedBusinessUnitData);
  if (!response.ok) {
    const error = new Error('Error executing "putBusinessUnit"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function deleteBusinessUnit(businessUnitId) {
  const response = await httpCall(`/api/business-unit/${businessUnitId}`, 'delete');
  if (!response.ok) {
    const error = new Error('Error executing "deleteBusinessUnit"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function getCurrencies(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/currencies${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCurrencies"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getCountCurrencies(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-currencies${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountCurrencies"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function postCurrency(currency) {
  const response = await httpCall(`/api/currency`, 'post', currency);
  if (!response.ok) {
    const error = new Error('Error executing "postCurrency"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getCurrency(currencyId) {
  const response = await httpCall(`/api/currency/${currencyId}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCurrency"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putCurrency(currencyId, updatedCurrencyData) {
  const response = await httpCall(`/api/currency/${currencyId}`, 'put', updatedCurrencyData);
  if (!response.ok) {
    const error = new Error('Error executing "putCurrency"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function deleteCurrency(currencyId) {
  const response = await httpCall(`/api/currency/${currencyId}`, 'delete');
  if (!response.ok) {
    const error = new Error('Error executing "deleteCurrency"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function getBudgetCapitals(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/budget-capitals${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBudgetCapitals"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getBudgetCapitalsExport(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/budget-capitals-export${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBudgetCapitalsExport"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.blob();
}

async function getCountBudgetCapitals(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-budget-capitals${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountBudgetCapitals"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getSubCategories(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/sub-categories${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getSubCategories"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getSuperitems(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/superitems${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getSuperitems"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getUsers(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/users${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getUsers"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getBudgetOperations(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/budget-operations${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBudgetOperations"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getBudgetOperationsExport(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/budget-operations-export${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getBudgetOperationsExport"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.blob();
}

async function getCountBudgetOperations(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-budget-operations${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountBudgetOperations"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getOperationTypes(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/operation-types${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getOperationTypes"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getSegments(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/segments${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getSegments"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getCountOperationTypes(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-operation-types${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountOperationTypes"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function postOperationType(operationType) {
  const response = await httpCall(`/api/operation-type`, 'post', operationType);
  if (!response.ok) {
    const error = new Error('Error executing "postOperationType"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getOperationType(operationTypeId) {
  const response = await httpCall(`/api/operation-type/${operationTypeId}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getOperationType"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putOperationType(operationTypeId, updatedOperationTypeData) {
  const response = await httpCall(`/api/operation-type/${operationTypeId}`, 'put', updatedOperationTypeData);
  if (!response.ok) {
    const error = new Error('Error executing "putOperationType"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function deleteOperationType(operationTypeId) {
  const response = await httpCall(`/api/operation-type/${operationTypeId}`, 'delete');
  if (!response.ok) {
    const error = new Error('Error executing "deleteOperationType"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function getCountSegments(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-segments${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountSegments"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function postSegment(segment) {
  const response = await httpCall(`/api/segment`, 'post', segment);
  if (!response.ok) {
    const error = new Error('Error executing "postSegment"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getSegment(segmentId) {
  const response = await httpCall(`/api/segment/${segmentId}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getSegment"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putSegment(segmentId, updatedSegmentData) {
  const response = await httpCall(`/api/segment/${segmentId}`, 'put', updatedSegmentData);
  if (!response.ok) {
    const error = new Error('Error executing "putSegment"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function deleteSegment(segmentId) {
  const response = await httpCall(`/api/segment/${segmentId}`, 'delete');
  if (!response.ok) {
    const error = new Error('Error executing "deleteSegment"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function getCountSubCategories(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-sub-categories${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountSubCategories"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function postSubCategory(subCategory) {
  const response = await httpCall(`/api/sub-category`, 'post', subCategory);
  if (!response.ok) {
    const error = new Error('Error executing "postSubCategory"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getSubCategory(subCategoryId) {
  const response = await httpCall(`/api/sub-category/${subCategoryId}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getSubCategory"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putSubCategory(subCategoryId, updatedSubCategoryData) {
  const response = await httpCall(`/api/sub-category/${subCategoryId}`, 'put', updatedSubCategoryData);
  if (!response.ok) {
    const error = new Error('Error executing "putSubCategory"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function deleteSubCategory(subCategoryId) {
  const response = await httpCall(`/api/sub-category/${subCategoryId}`, 'delete');
  if (!response.ok) {
    const error = new Error('Error executing "deleteSubCategory"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function getCountSuperitems(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-superitems${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountSuperitems"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function postSuperitem(superitem) {
  const response = await httpCall(`/api/superitem`, 'post', superitem);
  if (!response.ok) {
    const error = new Error('Error executing "postSuperitem"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getSuperitem(superitemId) {
  const response = await httpCall(`/api/superitem/${superitemId}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getSuperitem"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putSuperitem(superitemId, updatedSuperitemData) {
  const response = await httpCall(`/api/superitem/${superitemId}`, 'put', updatedSuperitemData);
  if (!response.ok) {
    const error = new Error('Error executing "putSuperitem"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function deleteSuperitem(superitemId) {
  const response = await httpCall(`/api/superitem/${superitemId}`, 'delete');
  if (!response.ok) {
    const error = new Error('Error executing "deleteSuperitem"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function getUser(userId) {
  const response = await httpCall(`/api/user/${userId}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getUser"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getUserRoles(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/user-roles${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getUserRoles"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getCountUserRoles(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-user-roles${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountUserRoles"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function postUserRole(userRole) {
  const response = await httpCall(`/api/user-role`, 'post', userRole);
  if (!response.ok) {
    const error = new Error('Error executing "postUserRole"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getUserRole(userRoleId) {
  const response = await httpCall(`/api/user-role/${userRoleId}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getUserRole"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function deleteUserRole(userRoleId) {
  const response = await httpCall(`/api/user-role/${userRoleId}`, 'delete');
  if (!response.ok) {
    const error = new Error('Error executing "deleteUserRole"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function getUsersV2(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/users/v2${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getUsersV2"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getCountUsers(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/count-users${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getCountUsers"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function postUser(user) {
  const response = await httpCall(`/api/user`, 'post', user);
  if (!response.ok) {
    const error = new Error('Error executing "postUser"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function putUser(userId, updatedUserData) {
  const response = await httpCall(`/api/user/${userId}`, 'put', updatedUserData);
  if (!response.ok) {
    const error = new Error('Error executing "putUser"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function deleteUser(userId) {
  const response = await httpCall(`/api/user/${userId}`, 'delete');
  if (!response.ok) {
    const error = new Error('Error executing "deleteUser"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return null;
}

async function getAggregateBudgetCapitals(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/aggregate-budget-capitals${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getAggregateBudgetCapitals"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

async function getAggregateBudgetOperations(args) {
  let queryString = '';
  if (args) {
    queryString = '?' + new URLSearchParams(args).toString();
  }
  const response = await httpCall(`/api/aggregate-budget-operations${queryString}`, 'get');
  if (!response.ok) {
    const error = new Error('Error executing "getAggregateBudgetOperations"');
    try {
      error.additionalData = await response.json();
    }
    catch (err) {
    }
    throw error;
  }
  return await response.json();
}

const ApiService = {
  getBranches,
  getCountBranches,
  postBranch,
  getBranch,
  putBranch,
  deleteBranch,
  getBudgetCapital,
  putBudgetCapitalSetInRevision,
  putBudgetCapitalSetConfirmed,
  putBudgetCapitalSetSent,
  putBudgetCapital,
  getBudgetCapitalAudits,
  getCountBudgetCapitalAudits,
  postBudgetCapitalComment,
  getBudgetCapitalComments,
  getCountBudgetCapitalComments,
  getBudgetOperation,
  putBudgetOperationSetInRevision,
  putBudgetOperationSetConfirmed,
  putBudgetOperationSetSent,
  putBudgetOperation,
  getBudgetOperationAudits,
  getCountBudgetOperationAudits,
  postBudgetOperationComment,
  getBudgetOperationComments,
  getCountBudgetOperationComments,
  getBusinessUnits,
  getCountBusinessUnits,
  postBusinessUnit,
  getBusinessUnit,
  putBusinessUnit,
  deleteBusinessUnit,
  getCurrencies,
  getCountCurrencies,
  postCurrency,
  getCurrency,
  putCurrency,
  deleteCurrency,
  getBudgetCapitals,
  getBudgetCapitalsExport,
  getCountBudgetCapitals,
  getSubCategories,
  getSuperitems,
  getUsers,
  getBudgetOperations,
  getBudgetOperationsExport,
  getCountBudgetOperations,
  getOperationTypes,
  getSegments,
  getCountOperationTypes,
  postOperationType,
  getOperationType,
  putOperationType,
  deleteOperationType,
  getCountSegments,
  postSegment,
  getSegment,
  putSegment,
  deleteSegment,
  getCountSubCategories,
  postSubCategory,
  getSubCategory,
  putSubCategory,
  deleteSubCategory,
  getCountSuperitems,
  postSuperitem,
  getSuperitem,
  putSuperitem,
  deleteSuperitem,
  getUser,
  getUserRoles,
  getCountUserRoles,
  postUserRole,
  getUserRole,
  deleteUserRole,
  getUsersV2,
  getCountUsers,
  postUser,
  putUser,
  deleteUser,
  getAggregateBudgetCapitals,
  getAggregateBudgetOperations,
}

export default ApiService;
